export enum Context {
  None,
  Success,
  Warning,
  Danger,
  Info
}


export enum Size {
  Default,
  Small,
  Large
}

export enum Visibility {
  Hidden,
  Visible
}

export enum TextFieldTypes {
  Email = 'email',
  Text = 'text',
  Password = 'password',
  Number = 'number'
}
